export const logMessage = (name) => (message, ...args) => {
  const ts = new Date().toISOString()
  console.log(`[${ts}] (${name}) - ${message}`, ...args)
}
